const EU_LANGS = new Set(['fr','de','it','es','nl','pt','pl','ro','cs','sk','hu','sv','da','fi','nb','nn','no','el','bg','hr','et','lv','lt','sl','mt','ga','lb']);
const NON_EU_COUNTRIES = new Set(['br','mx','ar','cl','co','pe','us','ca','au','nz','za','in','jp','cn','kr']);

function detectCurrency() {
  const lang = (navigator.language || 'fr-FR').toLowerCase();
  const [base, country] = lang.split('-');
  if (country && NON_EU_COUNTRIES.has(country)) return 'USD';
  if (EU_LANGS.has(base)) return 'EUR';
  // Swiss users: product is priced in EUR
  if (country === 'ch') return 'EUR';
  return 'USD';
}

const CONFIGS = {
  EUR: {
    code: 'EUR',
    format: (p) => `${p} €`,
    single: 9,
    premium: 29,
  },
  USD: {
    code: 'USD',
    format: (p) => `$${p}`,
    single: 10,
    premium: 32,
  },
};

export function useCurrency() {
  const code = detectCurrency();
  return CONFIGS[code];
}
